import { useQuery } from '@tanstack/react-query';

import { HomeFAQItem } from '../types';

import { getHomeFAQ } from './reference.api';

export function useGetHomeFaq() {
  return useQuery<HomeFAQItem[]>({
    queryKey: ['home-faq'],
    queryFn: getHomeFAQ
  });
}
